import * as React from 'react';
/**
 * @hidden
 */

export var ListNoData = function ListNoData(props) {
  return React.createElement("div", {
    className: "k-nodata"
  }, React.createElement("div", null, props.children));
};